import { Container, Eyebrow } from './primitives'

const STEPS = [
  {
    n: '01',
    title: 'Pay and send your brief.',
    body:
      'Stripe Checkout, then a 10-minute intake on the thank-you page. Logo, copy, references, domain. Done.',
  },
  {
    n: '02',
    title: 'Design and build, in seven days.',
    body:
      'First round lands on day three. One revision pass. Copy drafted from your intake if you want it.',
  },
  {
    n: '03',
    title: 'Live on your domain. Vello+ if you want it.',
    body:
      'Site deploys, CRM gets wired, keys come to you. Keep it as-is, or start a $299/mo retainer for edits.',
  },
]

export function HowItWorks() {
  return (
    <section style={{ padding: '96px 0', borderTop: '1px solid var(--line)' }}>
      <Container>
        <Eyebrow>How it works</Eyebrow>
        <div
          className="how-grid"
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: 48,
            marginTop: 48,
          }}
        >
          {STEPS.map((s) => (
            <div key={s.n}>
              <div
                style={{
                  fontFamily: 'var(--mono)',
                  fontSize: 12,
                  color: 'var(--accent)',
                  letterSpacing: '0.12em',
                  paddingBottom: 16,
                  borderBottom: '1px solid var(--line-strong)',
                }}
              >
                {s.n}
              </div>
              <h3
                style={{
                  fontSize: 26,
                  lineHeight: 1.2,
                  letterSpacing: '-0.02em',
                  fontWeight: 400,
                  margin: '24px 0 12px',
                  fontFamily: 'var(--serif)',
                }}
              >
                {s.title}
              </h3>
              <p
                style={{
                  fontSize: 15,
                  lineHeight: 1.6,
                  color: 'var(--muted)',
                  margin: 0,
                }}
              >
                {s.body}
              </p>
            </div>
          ))}
        </div>
      </Container>
    </section>
  )
}
